/*
    fake-referral-update.js

    This would probably use a referral id in the route, not service id.
*/

// questionTypes
import {
    SHORT_TEXT,
    LONG_TEXT,
    SINGLE_CHOICE,
    MULTI_CHOICE,
    NUMBER,
    DATE,
    COMMENT,
    SELECTION,
    BOOLEAN_CHECKBOX,
    RATING_STARS,
    // render custom UI fields
    OBJECT,
    CONTACT_INFO,
    MYSELF_INFO
} from './question-types.js';

export const SECTION_REFERRAL_UPDATE = {
    sectionId: "referral-update",
    sectionlabel: "Referral Update",
    nextSectionId: null,
    questions: [
        {
            id: "0000-0000",
            questionType: COMMENT,
            label: "Your Feedback",
            cssClass: "heading-1"
        },
        {
            id: "0000-0001",
            questionType: SINGLE_CHOICE,
            label: "Did you use the service provided?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: true,
            value: null
        },
        // 0000-0001 true questions
        {
            id: "0000-0002",
            questionType: SINGLE_CHOICE,
            label: "How often did you utilize the service?",
            options: [
                {label: "One-time", value: 'one-time'},
                {label: "A few times", value: 'a few times'},
                {label: "Recurring", value: 'recurring'},
                {label: "Other", value: 'other'}
            ],
            isRequired: false,
            value: null,
            depId: '0000-0001',
            depValue: true
        },
        {
            id: "0000-0003",
            questionType: DATE,
            label: "When did you start using the service?",
            placeholder: "Select start date",
            isRequired: false,
            value: null,
            depId: '0000-0001',
            depValue: true
        },
        {
            id: "0000-0004",
            questionType: SHORT_TEXT,
            label: "What aspects of this service were beneficial?",
            placeholder: "Resources given, employees of organization",
            isRequired: false,
            value: null,
            depId: '0000-0001',
            depValue: true
        },
        {
            id: "0000-0005",
            questionType: SHORT_TEXT,
            label: "What aspects of this service were not beneficial?",
            placeholder: "Time constraints, high price",
            isRequired: false,
            value: null,
            depId: '0000-0001',
            depValue: true
        },
        {
            id: "0000-0006",
            questionType: SINGLE_CHOICE,
            label: "Will you use this service again?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null,
            depId: '0000-0001',
            depValue: true
        },
        // 0000-0001 false questions
        {
            id: "0000-0007",
            questionType: SHORT_TEXT,
            label: "Why didn’t you use the service provided?",
            placeholder: "Didn’t fit into schedule, too expensive",
            isRequired: false,
            value: null,
            depId: '0000-0001',
            depValue: false
        },
        {
            id: "0000-0008",
            questionType: SHORT_TEXT,
            label: "What could help you utilize the service?",
            placeholder: "A different service, financial help, respite care",
            isRequired: false,
            value: null,
            depId: '0000-0001',
            depValue: false
        },
        {
            id: "0000-0009",
            questionType: COMMENT,          // only for vertical white space between questions
            label: "",
            cssClass: "spacer-1"            // takes up less height than a standard question
        },
        // final questions - always visible
        {
            id: "0000-0010",
            questionType: SHORT_TEXT,
            label: "Additional notes for service or specialist?",
            placeholder: "Concerns, suggestions, etc.",
            isRequired: false,
            value: null
        },
        {
            id: "0000-0011",
            questionType: SINGLE_CHOICE,
            label: "Would you like to keep this service on your plan?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null
        },
        {
            id: "0000-0012",
            questionType: SINGLE_CHOICE,
            label: "Would you like similar services added in the future?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null
        },
        {
            id: "0000-0013",
            questionType: COMMENT,          // only for vertical white space between questions
            label: "",
            cssClass: "spacer-1"            // takes up less height than a standard question
        },
        {
            id: "0000-0014",
            questionType: RATING_STARS,
            label: "Rate your service experience from 1-5 stars:",
            isRequired: false,
            isReadOnly: false,                  // is this needed? front end can set to false
            value: null                         // defaults to none (not 0)
        },
        {
            id: "0000-0015",
            questionType: BOOLEAN_CHECKBOX,
            label: "Make my service rating public",
            isRequired: false,
            value: true                         // defaults to checked
        }
    ]
}
